import { makeStyles } from '@material-ui/core';
import { Colors } from '../../layout/theme-next';

export default makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    color: Colors.primary,
    position: 'relative',
    pointerEvents: 'auto',
    cursor: 'pointer',
  },
  clickableAdornment: {
    pointerEvents: 'auto',
  },
  linkIcon: {
    marginRight: theme.spacing(0.5),
  },
}));
